import { ReactElement } from 'react';
import { Tag, TagProps, TagVariant } from '../Tag';
import styles from './DocumentStatusTag.module.scss';
import { joinClassNames } from '../../utils';
import { DangerFilledIcon, FileIcon, SuccessMiniIcon, WarningFilledIcon } from '../Graphics';

export enum DocumentStatusTagVariant {
  Downloaded = 'downloaded',
  Obsolete = 'obsolete',
  NotAccessed = 'notAccessed',
  HasDocs = 'hasDocs',
  HardCopy = 'hardCopy',
}

export type DocumentStatusTagProps = Omit<TagProps, 'variant'> & {
  variant?: DocumentStatusTagVariant;
};

const IconHelper = ({ variant }: { variant: DocumentStatusTagVariant }) => {
  switch (variant) {
    case DocumentStatusTagVariant.Downloaded:
      return <SuccessMiniIcon />;
    case DocumentStatusTagVariant.Obsolete:
      return <DangerFilledIcon />;
    case DocumentStatusTagVariant.NotAccessed:
      return <WarningFilledIcon />;
    case DocumentStatusTagVariant.HasDocs:
      return <FileIcon />;
    case DocumentStatusTagVariant.HardCopy:
      return null;
  }
};

export const DocumentStatusTag = ({
  variant = DocumentStatusTagVariant.NotAccessed,
  children,
  className,
  ...props
}: DocumentStatusTagProps): ReactElement => {
  return (
    <Tag
      variant={TagVariant.Plain}
      className={joinClassNames(styles.documentStatusTag, styles[variant], className)}
      {...props}
    >
      <IconHelper variant={variant} />
      {children}
    </Tag>
  );
};

DocumentStatusTag.displayName = 'DocumentStatusTag';
